<template>
  <b-input-group
    :style="'max-width:' + maxwidth +'px!important'"
  >
    <b-input-group-prepend>
      <b-button
        variant="outline-dark"
        class="py-0"
        size="sm"
        :disabled="disabled"
        :readonly="readonly"
        @click="valueChange((value*1) - 1)"
      >
        <feather-icon
          size="16"
          icon="MinusIcon"
        />
      </b-button>
    </b-input-group-prepend>
    <b-form-input
      :id="id"
      :size="size"
      :value="value"
      type="number"
      :disabled="disabled"
      :readonly="readonly"
      :min="min"
      :max="max"
      number
      class="border-secondary text-center"
      @update="valueChange"
    />

    <b-input-group-append>
      <b-button
        variant="outline-dark"
        class="py-0"
        size="sm"
        :disabled="disabled"
        :readonly="readonly"
        @click="valueChange((value*1) + 1)"
      >
        <feather-icon
          size="16"
          icon="PlusIcon"
        />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>
<script>
import {
  BFormInput, BInputGroupPrepend, BInputGroupAppend, BButton, BInputGroup,
} from 'bootstrap-vue'

export default {
  name: 'BFormSpinbuttonInput',

  components: {
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BButton,
    BInputGroup,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'md',
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value)
      },
    },
    value: {
      type: [Number, String],
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 999999999,
      required: false,
    },
    width: {
      type: Number,
      default: 0,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    maxwidth() {
      if (this.width === 0) {
        return 120
      }
      return this.width
    },
  },
  methods: {
    valueChange(newValue) {
      if (newValue <= 0) {
        this.$emit('input', 0)
      } else {
        this.$emit('input', newValue)
      }
    },
  },
}

</script>
<style scoped>
/* Remove up and down arrows inside number input */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
    border-color:#D8D6DE!important;
    width: 45px!important;
}
button{
    padding: 6px!important;
    border-color:#D8D6DE!important
}
button.disabled{
  background:#EFEFEF !important;
}
</style>
